import { render, staticRenderFns } from "./ClockLogsReport.vue?vue&type=template&id=5fabba29"
import script from "./ClockLogsReport.vue?vue&type=script&lang=js"
export * from "./ClockLogsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports